export enum SubsectorConstant {
  KESKVALITSUS = 'KESKVALITSUS',
  KOHALIK_OMAVALITSUS = 'KOHALIK OMAVALITSUS',
  SOTSIAALKINDLUSTUSFOND = 'SOTSIAALKINDLUSTUSFOND'
}
